import { render, staticRenderFns } from "./RevenueResponseModal.vue?vue&type=template&id=2d1f491a&"
import script from "./RevenueResponseModal.vue?vue&type=script&lang=js&"
export * from "./RevenueResponseModal.vue?vue&type=script&lang=js&"
import style0 from "./RevenueResponseModal.vue?vue&type=style&index=0&id=2d1f491a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports